export {
  PrimaryControlsStripTitleContext,
  createPrimaryControlsStripTitleRegistry,
  type PrimaryControlsStripTitleRegistry,
} from "#primary-controls-strip-title-context";
export { PrimaryControlsStripTitleProvider } from "#primary-controls-strip-title-provider";
